import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import {withTranslation} from "react-i18next";
import {translate} from "../../../../../../translations/i18n";

const rows = [
  {
    id: 'title', align: 'left', disablePadding: true, label: translate('posts.drafts.table.title'),
  },
  {
    id: 'categories', align: 'left', disablePadding: false, label: translate('posts.drafts.table.categories'),
  },
  {
    id: 'tags', align: 'left', disablePadding: false, label: translate('posts.drafts.table.tags'),
  },
  {
    id: 'username', align: 'left', disablePadding: false, label: translate('posts.drafts.table.author'),
  },
  {
    id: 'scheduled', align: 'left', disablePadding: false, label: translate('posts.drafts.table.scheduled_at'),
  },
  {
    id: 'updatedAt', align: 'left', disablePadding: false, label: translate('posts.drafts.table.updated_at'),
  },
];

class DraftsHead extends PureComponent {
  static propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  createSortHandler = property => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      order, orderBy, t
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
           
          </TableCell>
          {rows.map(row => (
            <TableCell
              className="material-table__cell material-table__cell--sort"
              key={row.id}
              align={row.align}
              padding={row.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === row.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === row.id}
                direction={order}
                onClick={this.createSortHandler(row.id)}
                className="material-table__sort-label"
              >
                {row.label}
              </TableSortLabel>
            </TableCell>
            ), this)}
            <TableCell
              className="material-table__cell material-table__cell--sort"
              align={'left'}
              padding={'default'}>
              <TableSortLabel className="material-table__sort-label">{t('posts.drafts.table.action')}</TableSortLabel>
            </TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

export default withTranslation('dashboard')(DraftsHead)
